import { html } from '@design.estate/dees-element';
import { demoPage, demoOutput, showDemoResult } from '../../../demos/templates.js';

const logResponse = (event: CustomEvent) => {
  const card = event.target as HTMLElementTagNameMap['dees-harness-question-card'];
  card.request = { ...card.request, response: event.detail.answers, respondedAt: Date.now() };
  showDemoResult(event.currentTarget as Element, event.detail);
};

export const demoFunc = () => demoPage('Questions', 'Single choices, multiple choices and written answers.', html`
  <div class="questionDemo dees-demo-stack" @harness-question-response=${logResponse}>
    <dees-harness-question-card
      .request=${{
        id: 'q1',
        question: 'Which database should the new service use?',
        createdAt: Date.now(),
        options: [
          { label: 'PostgreSQL', description: 'Relational, already in the stack' },
          { label: 'MongoDB', description: 'Document store, flexible schema' },
          { label: 'SQLite', description: 'Embedded, zero ops' },
        ],
      }}
    ></dees-harness-question-card>
    <dees-harness-question-card
      .request=${{
        id: 'q2',
        question: 'Which environments should the rollout include?',
        multiSelect: true,
        allowCustom: false,
        options: [
          { label: 'staging' },
          { label: 'production-eu' },
          { label: 'production-us' },
        ],
      }}
    ></dees-harness-question-card>
    <dees-harness-question-card
      .request=${{
        id: 'q3',
        question: 'Anything else I should know before migrating?',
        options: [],
      }}
    ></dees-harness-question-card>
    <dees-harness-question-card
      busy
      .request=${{
        id: 'q-busy',
        question: 'Waiting for the runtime — which region?',
        options: [{ label: 'eu-central' }, { label: 'us-east' }],
      }}
    ></dees-harness-question-card>
    <dees-harness-question-card
      .request=${{
        id: 'q4',
        question: 'Which framework for the admin UI?',
        options: [{ label: 'Lit' }, { label: 'React' }],
        response: ['Lit'],
        respondedAt: Date.now() - 60_000,
      }}
    ></dees-harness-question-card>
    ${demoOutput()}
  </div>
`);
